// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { ErrorIssueStatus } from "./Shared.ErrorIssueStatus.gen";
import { ErrorSeverity } from "./Shared.ErrorSeverity.gen";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsNotEmpty, IsOptional, Length, MaxLength, MinLength } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface IErrorDetailsEntity {
	hashId: string;

	details: string;

	stackTrace: string | undefined;

	stackTraceFirmwareVersion: string | undefined;

	firstSeenAt: string | undefined;

	lastSeenAt: string | undefined;

	status: ErrorIssueStatus;

	resolvedInFirmwareVersion: string | undefined;

	severity: ErrorSeverity | undefined;

	notes: string | undefined;

	statusChangedByUserId: string | undefined;

	statusChangedAt: string | undefined;

	$type?: string | undefined;
}
export class ErrorDetailsEntity {
	constructor(data?: IErrorDetailsEntity) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.firstSeenAt) { this.firstSeenAt = new Date(data.firstSeenAt); }
		if (data.lastSeenAt) { this.lastSeenAt = new Date(data.lastSeenAt); }
		if (data.statusChangedAt) { this.statusChangedAt = new Date(data.statusChangedAt); }
	}

	@Length(0, 32)
	@IsNotEmpty()
	hashId: string = "";

	@IsNotEmpty()
	@MinLength(1)
	details: string = "";

	stackTrace: string | undefined;

	@IsOptional()
	@MaxLength(64)
	stackTraceFirmwareVersion: string | undefined;

	firstSeenAt: Date | undefined = new Date();

	lastSeenAt: Date | undefined = new Date();

	status: ErrorIssueStatus = 0;

	@IsOptional()
	@MaxLength(64)
	resolvedInFirmwareVersion: string | undefined;

	severity: ErrorSeverity | undefined;

	notes: string | undefined;

	statusChangedByUserId: string | undefined;

	statusChangedAt: Date | undefined;

	static $type: string = "CoreApi.Entities.ErrorDetailsEntity, ";
	$type?: string | undefined = ErrorDetailsEntity.$type;
}

